"use client";

import { useStudentRatingCourses } from "@/api/hook/useCourses";

interface CoursesModalProps {
  isOpen: boolean;
  onClose: () => void;
  studentId: number;
  studentName: string;
  totalCourses: number;
}

export function CoursesModal({
  isOpen,
  onClose,
  studentId,
  studentName,
  totalCourses,
}: CoursesModalProps) {
  const {
    data: courses,
    isLoading,
    error,
  } = useStudentRatingCourses(studentId);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[85vh] overflow-hidden flex flex-col">
        {/* Header */}
        <div className="p-6 border-b border-gray-200">
          <h2 className="text-xl font-semibold text-gray-900">
            {studentName}'s Certificates
          </h2>
          <p className="text-sm text-[#ff0606] mt-2">
            Total Courses Completed:{" "}
            <span className="font-semibold">{totalCourses}</span>
          </p>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto">
          {isLoading ? (
            <div className="flex items-center justify-center py-8">
              <p className="text-gray-600">Loading courses...</p>
            </div>
          ) : error ? (
            <div className="text-center py-8 text-red-600">
              <p>Failed to load courses. Please try again.</p>
            </div>
          ) : !courses || courses.length === 0 ? (
            <div className="text-center py-8 text-gray-600">
              <p>No courses found for this student.</p>
            </div>
          ) : (
            <ul className="divide-y divide-gray-100">
              {courses.map((course, index) => {
                const courseName =
                  (course as any).studentCourse?.course?.courseName ||
                  (course as any).courseName ||
                  "Untitled Course";

                return (
                  <li
                    key={course.id}
                    className={`text-sm  leading-relaxed px-3 py-3 ${
                      index % 2 === 0 ? "bg-[#FFF]" : "bg-[#f9fafbb2]"
                    }`}
                  >
                    <span className="text-[#ff0404]">{index + 1}. </span>{" "}
                    {courseName.toUpperCase()}
                  </li>
                );
              })}
            </ul>
          )}
        </div>

        {/* Footer */}
        <div className="p-6 border-t border-gray-200 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-[#e01212] text-[#FFF] rounded hover:bg-[#e01212]/80 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
